<template>
  <div class="col-lg-4 col-md-6 ml-auto mr-auto access-denied-page">
    <info-section
      class="mt-5"
      type="danger"
      title="Marketing"
      description="We've created the marketing campaign of the website. It was a very interesting collaboration."
      icon="nc-icon nc-alert-circle-i">
      <h2 class="text-muted mt-3">
        Недостаточно прав
      </h2>
      <small class="text-muted">Страница недоступна для текущего пользователя.
        <br>
        <router-link v-if="!!role" :to="startPagePath">
          <p-button type="info">На главную</p-button>
        </router-link>
        <p-button @click="handleClickExit">Выход</p-button>
      </small>
    </info-section>
  </div>
</template>
<script>
  import { InfoSection } from 'src/components/UIComponents';
  export default {
    components: {
      InfoSection
    },
    computed: {
      role() {
        const user = this.$store.getters.user
        if (!user) return
        return user.roles[0].name
      },
      startPagePath() {
        if (!this.role) return
        return this.$sidebar.getStartPage(this.role)
      }
    },
    methods: {
      handleClickExit() {
        this.$store.dispatch('logout')
        this.$router.push(`/${this.$i18n.locale}/login`)
      }
    }
  }
</script>
<style>
</style>
